<template>
    <div class="flex cursor-pointer gap-2" :class="{ 'w-full': label }" @click="toggle">
        <span :class="tickClass">
            <tick-icon v-if="value"></tick-icon>
        </span>
        <span v-if="label" :class="`${labelClass || 'text-white'}`">{{ label }}</span>
    </div>
</template>

<script>
import { twMerge } from 'tailwind-merge';
import TickIcon from '../assets/check.svg';

export default {
    name: 'GdCheckbox',
    components: {
        TickIcon,
    },
    props: {
        value: { type: [Boolean, Number], default: false },
        disabled: { type: Boolean, default: false },
        label: { type: String, default: ''},
        labelClass: { type: String, default: '' },
        overrideBase: { type: String, default: ''},
        variant: { type: String, default: 'base' },
        size: { type: String, default: 'md' },
    },
    computed: {
        tickClass() {
            const baseClass = 'flex-none flex items-center justify-center rounded border text-grey-500';
            const sizeClass = {
                sm: 'w-5 h-5',
                md: 'w-6 h-6',
                lg: 'w-7 h-7',
            };
            const variantClass = {
                base: 'border-grey-200 text-grey-500',
                primary: 'border-grey-200 text-primary-invert',
                dark: 'border-secondary-lighter text-secondary-invert',
                outline: 'bg-transparent'
            };
            const selectedClass = {
                base: 'bg-grey-200',
                primary: 'bg-primary border-primary',
                dark: 'bg-secondary border-secondary',
                outline: 'bg-transparent'
            };
            const disabledClass = 'cursor-not-allowed filter contrast-50';
            return twMerge(baseClass, sizeClass[this.size], variantClass[this.variant], this.overrideBase, this.value ? selectedClass[this.variant] : '', this.disabled ? disabledClass : '');
        },
    },
    methods: {
        toggle() {
            if (!this.disabled) {
                this.$emit('input', !this.value);
                this.$emit('change', !this.value);
            }
        },
    },
};
</script>
